export default __webpack_public_path__ + "static/media/learose5-1440w.d8ac821c.png";